import { PageHeader } from '../../Components';
import { PageFooter } from '../../Components/PageFooter/PageFooter';
import { Intro } from '../../Components/Intro/Intro';
import { Calculator } from '../../Components/Calculator/Calculator';
import { Results } from '../../Components/Results/Results';
import './homeScreen.css';
import { useEffect, useState } from 'react';

enum Elements {
    Intro,
    Calculator, 
    Result
}

export function HomeScreen() {
    const [answers, setAnswers] = useState<Record<string, number>>({});
    const [currentElement, setCurrentElement] = useState<Elements>(Elements.Intro);
    
    useEffect(() => {
        setCurrentElement(Elements.Intro);
    }, []);


    const handleStartButton = () => {
        setCurrentElement(Elements.Calculator);
    };

    const handleBackButton = () => {
        setCurrentElement(Elements.Intro);
    };

    const handleEnd = () => {
        setCurrentElement(Elements.Result);
    };

    const onAnswerChange = (questionKey: string, value: number) => {
        setAnswers(prev => ({
            ...prev,
            [questionKey]: value
        }));
    };

    const onReset = () => {
        setAnswers({});
        setCurrentElement(Elements.Intro);
    };

    return (
        <div className="home-screen">
            <PageHeader />
            {currentElement === Elements.Intro && <Intro onStartButton={handleStartButton} />}
            {currentElement === Elements.Calculator && <Calculator onBack={handleBackButton} answers={answers} onAnswerChange={onAnswerChange} onEnd={handleEnd} />}
            {currentElement === Elements.Result && <Results answers={answers} onReset={onReset} />}
            <PageFooter />
        </div>
    );
}